import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { ContactInteractionModel, ContactModel } from '../models/contact.model';
import {
  IContactApiProps,
  IContactForm,
  IGenericInteractionProps,
} from '../repositories/IContact.repository';

export interface IContactsService<T1, T2> {
  loadRemoteContacts(): Observable<T2[]>;
  loadContactInteractions(
    contactId: number
  ): Observable<ContactInteractionModel[]>;
  loadRawNativeContacts(filter?: string): Observable<T1[]>;
  loadFormattedNativeContacts(filter?: string): Observable<T2[]>;
  createContact(form: IContactForm): Observable<T2>;
  delete(contactId: number): Observable<number>;
  update(form: IContactForm): Observable<T2>;
  import(contactList: IContactApiProps[]): Observable<T2[]>;
  pickOne(phone: string): Observable<T1 | null>;
  createInteraction(
    contactId: number,
    config: IGenericInteractionProps
  ): Observable<ContactInteractionModel>;
}

export const CONTACTS_SERVICE = new InjectionToken<
  IContactsService<any, ContactModel>
>('contactsService');
